import { useContext } from 'react'

import { SearchSessionContext } from './SearchSessionContext'

export const useSearchSessionContext = () => {
  const value = useContext(SearchSessionContext)
  if (value === undefined) {
    throw new Error(
      'Context value is undefined, are you missing the SearchSessionProvider?',
    )
  }
  return value
}
